import fuzhu from "../../api/fuzhu";
import {getBaseUrl} from "@/helpers/request";

const state = {
    // 部门列表
    buMenListLoading: false,
    buMenList: {},
    // 类别列表
    leiBieListLoading: false,
    leiBieList: {},
    rowDetails: {},
    addTagAttributeVisible: false,
    // 角色列表
    roleListLoading: false,
    roleList: {},
    roleListFilter: {},
    // 角色列表
    workOrderListModalVisible: false,
    workOrderListLoading: false,
    workOrderList: {},
    workOrderListFilter: {
        handled: "false"
    },
    chatDocContent: null,
    chatDocContentLoading: false,
    // 咨询管理
    consultingListFilter: {},
    consultingList: {},
    consultingListLoading: false,
};

const getters = {};

const mutations = {
    setData(state, {key, value}) {
        state[key] = value;
    },
    clearFilter(state) {
        state.roleListFilter = {};
    },
    clearWorkOrderListFilter(state) {
        state.workOrderListFilter = {
            handled: "false"
        };
    },
};

const actions = {
    // 咨询回答
    // eslint-disable-next-line no-empty-pattern
    async answerConsulting({commit}, payload) {
        const res = await fuzhu.answerConsulting(payload);
        return res.data
    },
    // 咨询对话内容
    // eslint-disable-next-line no-empty-pattern
    async getChatLog({commit}, payload) {
        const res = await fuzhu.getChatLog(payload);
        return res.data
    },
    // 用户咨询列表
    // eslint-disable-next-line no-empty-pattern
    async getUserChatLogOverview({commit}, payload) {
        commit("setData", {key: "consultingListLoading", value: true});
        try {
            const params = {
                size: state.consultingList.size,
                ...payload,
            };
            const res = await fuzhu.getUserChatLogOverview(params);
            commit("setData", {key: "consultingList", value: res.data});
        } finally {
            commit("setData", {key: "consultingListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async askDoc({commit}, {question, subject}) {
        commit("setData", {key: "chatDocContentLoading", value: true});
        let baseUrl = getBaseUrl();
        let xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.open('GET', baseUrl + '/assist/askDoc?question=' + question + '&subject=' + subject);
        xhr.onprogress = function (e) {
            commit("setData", {key: "chatDocContent", value: e.target.response});
        };
        xhr.onloadend = function () {
            commit("setData", {key: "chatDocContentLoading", value: false});
        }
        xhr.onerror = function () {
            commit("setData", {key: "chatDocContentLoading", value: false});
        }
        xhr.send();
    },
    // eslint-disable-next-line no-empty-pattern
    async getDocSubjectList({commit}) {
        return await fuzhu.getDocSubjectList();
    },
    // 部门列表
    // eslint-disable-next-line no-empty-pattern
    async getBuMenList({commit}, payload) {
        commit("setData", {key: "buMenListLoading", value: true});
        try {
            const params = {
                size: state.buMenList.size,
                ...payload,
            };
            const res = await fuzhu.getBuMenList.getList(params);
            commit("setData", {key: "buMenList", value: res.data});
        } finally {
            commit("setData", {key: "buMenListLoading", value: false});
        }
    },
    // 移动部门
    // eslint-disable-next-line no-empty-pattern
    async moveAssistDepart({commit}, payload) {
        return await fuzhu.moveAssistDepart(payload);
    },
    // 新增编辑部门
    // eslint-disable-next-line no-empty-pattern
    async saveBuMen({}, payload) {
        await fuzhu.saveBuMen(payload);
    },
    // 删除部门
    // eslint-disable-next-line no-empty-pattern
    async deleteBuMen({}, payload) {
        await fuzhu.deleteBuMen(payload);
    },
    // 类别列表
    // eslint-disable-next-line no-empty-pattern
    async getLeiBieList({commit}, payload) {
        commit("setData", {key: "leiBieListLoading", value: true});
        try {
            const params = {
                ...payload,
            };
            const res = await fuzhu.getLeiBieList.getList(params);
            commit("setData", {key: "leiBieList", value: res.data});
        } finally {
            commit("setData", {key: "leiBieListLoading", value: false});
        }
    },
    // 移动类别
    // eslint-disable-next-line no-empty-pattern
    async moveLeiBie({commit}, payload) {
        await fuzhu.moveLeiBie(payload);
    },
    // 新增编辑类别
    // eslint-disable-next-line no-empty-pattern
    async saveLeiBie({}, payload) {
        await fuzhu.saveLeiBie(payload);
    },
    // 删除类别
    // eslint-disable-next-line no-empty-pattern
    async deleteLeiBie({}, payload) {
        await fuzhu.deleteLeiBie(payload);
    },
    //     角色列表
    // eslint-disable-next-line no-empty-pattern
    async getRoleList({commit}, payload) {
        commit("setData", {key: "roleListLoading", value: true});
        try {
            const params = {
                size: state.roleList.size,
                page: state.roleList.page,
                ...state.roleListFilter,
                ...payload,
            };
            const res = await fuzhu.getRoleList.getList(params);
            commit("setData", {key: "roleList", value: res.data});
        } finally {
            commit("setData", {key: "roleListLoading", value: false});
        }
    },
    // 移动类别
    // eslint-disable-next-line no-empty-pattern
    async moveAssistRole({commit}, payload) {
        const params = {
            ...state.roleListFilter,
            ...payload,
        };
        return await fuzhu.moveAssistRole(params);
    },
    // 新增编辑角色
    // eslint-disable-next-line no-empty-pattern
    async saveRole({}, payload) {
        return await fuzhu.saveRole(payload);
    },
    // 删除角色
    // eslint-disable-next-line no-empty-pattern
    async deleteRole({}, payload) {
        return await fuzhu.deleteRole(payload);
    },
    // 上下线角色
    // eslint-disable-next-line no-empty-pattern
    async deployAssistRole({}, payload) {
        await fuzhu.deployAssistRole(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async readDocument({}, payload) {
        return await fuzhu.readDocument(payload);
    },
    //     角色列表
    // eslint-disable-next-line no-empty-pattern
    async getAssistWorkOrder({commit}, payload) {
        commit("setData", {key: "workOrderListLoading", value: true});
        try {
            const params = {
                ...state.workOrderListFilter,
                ...payload,
            };
            if (state.workOrderListFilter.dateRange &&
                state.workOrderListFilter.dateRange.length === 2) {
                params.startTime = state.workOrderListFilter.dateRange ? state.workOrderListFilter.dateRange[0] : null;
                params.endTime = state.workOrderListFilter.dateRange ? state.workOrderListFilter.dateRange[1] : null;
            }
            const res = await fuzhu.getAssistWorkOrder.getList(params);
            commit("setData", {key: "workOrderList", value: res.data});
        } finally {
            commit("setData", {key: "workOrderListLoading", value: false});
        }
    },
    async handleAssistWorkOrder({}, id) {
        return await fuzhu.handleAssistWorkOrder({id});
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
